export default "__VITE_ASSET__DYCbctPV__"